import { Link } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="border-t border-background-800 bg-primary-950">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 font-heading text-xl font-black leading-none text-primary-700">
                18
              </span>
              <span className="font-heading text-xl font-black text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-7 text-background-300">
              {siteInfo.tagline}。聚合娱乐热点、明星动态与圈内话题，用清晰的时间线与多源比对，帮你把一件事看完整。
            </p>
            <p className="mt-5 text-sm text-background-300">
              线索投稿 / 合作邮箱：
              <a
                href={`mailto:${siteInfo.email}`}
                className="ml-1 text-accent-400 hover:text-accent-300"
              >
                {siteInfo.email}
              </a>
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-medium text-background-50">
              <span className="border-l-2 border-accent-500 pl-2">快速导航</span>
            </h4>
            <ul className="mt-4 space-y-3">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-medium text-background-50">
              <span className="border-l-2 border-accent-500 pl-2">热门栏目</span>
            </h4>
            <ul className="mt-4 space-y-3">
              {categories.slice(0, 4).map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/topics?c=${c.slug}`}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-medium text-background-50">
              <span className="border-l-2 border-accent-500 pl-2">关于</span>
            </h4>
            <ul className="mt-4 space-y-3">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 transition-colors hover:text-accent-400"
                >
                  网站介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about#principles"
                  className="text-sm text-background-300 transition-colors hover:text-accent-400"
                >
                  内容原则
                </Link>
              </li>
              <li>
                <Link
                  to="/about#contact"
                  className="text-sm text-background-300 transition-colors hover:text-accent-400"
                >
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} {siteInfo.name}. 内容仅供娱乐资讯参考。
          </p>
          <p className="text-xs text-background-400">
            站内所涉人物均为公开话题的资讯整理，如涉侵权请联系 {siteInfo.email}
          </p>
        </div>
      </div>
    </footer>
  );
}